import { forwardRef } from 'react';
import type { PropsWithoutRef, CSSProperties } from 'react';

import type { ForwardRefForwardPropsComponent } from '../../types';

import { StyledProgressBar } from './Progress.styles';
import type { ProgressProps } from './Progress.types';

const Bar: ForwardRefForwardPropsComponent<ProgressProps> = forwardRef(function Bar(
  {
    value,
    minValue = 0,
    maxValue = 100,
    message,
    placement,
    style,
    ...restProps
  }: PropsWithoutRef<ProgressProps & { style?: CSSProperties }>,
  ref: ProgressProps['ref']
) {
  let percentage = value;

  if (typeof value === 'number') {
    if (value > maxValue || minValue > maxValue) percentage = 0;
    else if (value < minValue) percentage = 100;
    else percentage = (1 - (value - minValue) / (maxValue - minValue)) * -100;
  }

  return (
    <StyledProgressBar
      ref={ref}
      role='progressbar'
      aria-valuemin={minValue}
      aria-valuemax={maxValue}
      aria-valuenow={value}
      placement={placement}
      determinate={typeof value === 'number'}
      style={{ ...style, '--progress': percentage ? `${percentage}%` : '' } as CSSProperties}
      {...restProps}
    />
  );
});

export default Bar;
